import axios from "axios";
import router from "@/router";
import alert from "@/lang/AlertMessages.js";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.token;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept-Language"] = "fa";

export default {
  login({ dispatch, commit }, data) {
    commit("setLoginCheck", true);
    axios
      .post("Account", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        commit("authUser", res.data.access_token);
        localStorage.setItem("token", res.data.access_token);
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + res.data.access_token;
        router.push({ name: "Dashboard" });
        setTimeout(() => {
          commit("setSuccess", alert.success.login, { root: true });
        }, 800);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoginCheck", false);
        }, 1000);
      });
  },

  verifyForgotCode({ commit, dispatch }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Account/Authentication", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        commit("setRecoveryAuth", res.data.data);
        localStorage.setItem("panelToken", res.data.data.access_token);
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + res.data.data.access_token;
        commit("setSuccess", alert.success.AuthDone, { root: true });
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  resetPassword({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Account/ResetPassword", data, data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.resetPassword,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  forgotPassword({ commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Account/ForgotPassword", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(() => {
        commit("setSuccess", alert.success.codeSent, { root: true });
        commit("setForgotCheck", true);
        setTimeout(() => {
          commit("setForgotCheck", false);
        }, 800);
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          const errMsg =
            error.response.data.message + "چند ثانیه دیگر مجدد امتحان کنید";
          commit("setError", errMsg, { root: true });
        }
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  logout({ commit }) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    axios.defaults.headers.common["Authorization"] = "";
    commit("clearAuth");
    router.push({ name: "Login" });
  },

  getCaptcha({ commit }) {
    axios
      .get("Account/CreateCaptcha", { withCredentials: true })
      .then((res) => {
        commit("setCaptcha", res.data);
      })
      .catch(() => {
        commit("setError", alert.error.loadCaptcha, { root: true });
      });
  },

  ///////////////////////////////////////////////////

  // Profile Actions ----------------------------------------------------------------
  getCurrentUser({ dispatch, commit }) {
    axios
      .get("profile")
      .then((res) => {
        commit("setCurrentUser", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  editProfile({ commit, dispatch }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("profile", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          { server: res, message: alert.success.editProfile, redirect: false },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editAvatar({ dispatch }, data) {
    axios
      .post("profile", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          { server: res, message: alert.success.changeAvatar, redirect: false },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteAvatar({ dispatch }) {
    axios
      .delete("Profile")
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          { server: res, message: alert.success.changeAvatar, redirect: false },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  editPassword({ commit, dispatch }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("profile/ChangePassword", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.changePassword,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // fiscalYear update ---------------------------------------------------------------------------------
  getFiscalYear({ dispatch, commit }) {
    axios
      .get("profile/UserFiscalYear")
      .then((res) => {
        commit("setFiscalYear", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  editUpdateFiscalYear({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("Account/UpdateFiscalYear", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        commit("authUser", res.data);
        localStorage.setItem("token", res.data.access_token);
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + res.data.access_token;
        const msg = "سال مالی با موفقیت تغییر یافت";
        commit("setSuccess", msg, { root: true });
        dispatch("getFiscalYear");
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Alert and Errors Handler ------------------------------------------------------
  successPOSTHandler({ commit }, data) {
    if (data.server && data.server.status === 200) {
      commit("setSuccess", data.message, { root: true });
      commit("setPostCheck", true, { root: true });
      setTimeout(() => {
        commit("setPostCheck", false, { root: true });
      }, 800);
      if (data.redirect) {
        setTimeout(() => {
          router.push({ name: data.redirect });
        }, 2500);
      }
    } else if (data.server.data && data.server.data.message != "") {
      commit("setError", data.server.data.message, { root: true });
      commit("setPostCheck", false, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
      commit("setPostCheck", false, { root: true });
    }
  },

  successPOSTHandlerSimple({ commit }, data) {
    if (data.server && data.server.status === 200) {
      commit("setSuccess", data.message, { root: true });
    } else if (data.server.data && data.server.data.message != "") {
      commit("setError", data.server.data.message, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
    }
  },

  errorPOSTHandler({ dispatch, commit }, data) {
    commit("setPostCheck", false, { root: true });
    if (data.response && data.response.status === 403) {
      commit("setError", alert.error.access, { root: true });
    } else if (data.response && data.response.status === 401) {
      dispatch("logout", null, { root: true });
    } else if (data.response.data.message && data.response.data.message != "") {
      commit("setError", data.response.data.message, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
    }
  },

  errorGETHandler({ dispatch, commit }, data) {
    commit("setPostCheck", false, { root: true });
    if (data.response && data.response.status === 403) {
      router.push({ name: "Page403" });
    } else if (data.response && data.response.status === 401) {
      dispatch("logout", null, { root: true });
    } else if (data.response.data.message && data.response.data.message != "") {
      commit("setError", data.response.data.message, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
    }
  },
};
